export default {
  namespaced: true,

  state: {
    target: null,
    actions: null,
    content: null,
  },

  mutations: {
    SET_TARGET(state, target) {
      state.target = target;
    },
    SET_ACTIONS(state, actions) {
      state.actions = actions;
    },
    SET_CONTENT(state, content) {
      state.content = content;
    },
  },

  actions: {
    SHOW({ commit }, data) {
      commit('SET_TARGET', data.target || null);
      commit('SET_ACTIONS', data.actions || null);
      commit('SET_CONTENT', data.content || null);
    },
    HIDE({ commit }) {
      commit('SET_TARGET', null);
      commit('SET_ACTIONS', null);
      commit('SET_CONTENT', null);
    },
  },

  getters: {
    hasContent: (state) => `${state.content || ''}`.trim() !== '',
    hasActions: (state) => (Array.isArray(state.actions) && state.actions.length > 0),
    visible: (state, getters) => state.target !== null && (getters.hasContent || getters.hasActions),
  },
};
